import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import { TextField, Button, FormControlLabel, Checkbox, Box, Typography, Stack } from '@mui/material'
import AuthLayout from '@/components/layouts/AuthLayout'
import { SPACING } from '@/theme'

interface Props {
  rememberable?: boolean
}

export default function Login({ rememberable = true }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      remember_me: false,
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/users/sign_in')
  }

  return (
    <AuthLayout title="Sign in to your account">
      <Stack component="form" onSubmit={handleSubmit} spacing={SPACING.gap.md}>
        <TextField
          label="Email address"
          type="email"
          fullWidth
          value={data.user.email}
          onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
          error={!!errors.email}
          helperText={errors.email}
          autoFocus
          autoComplete="email"
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          value={data.user.password}
          onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
          error={!!errors.password}
          helperText={errors.password}
          autoComplete="current-password"
        />
        {rememberable && (
          <FormControlLabel
            control={
              <Checkbox
                checked={data.user.remember_me}
                onChange={(e) => setData('user', { ...data.user, remember_me: e.target.checked })}
              />
            }
            label="Remember me"
          />
        )}
        <Button type="submit" variant="contained" fullWidth size="large" disabled={processing}>
          Sign in
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2">
            <Link href="/users/password/new">Forgot your password?</Link>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Don't have an account? <Link href="/users/sign_up">Sign up</Link>
          </Typography>
        </Box>
      </Stack>
    </AuthLayout>
  )
}
